const doc = [({"ko":({"adminConstantUserType":({"common":"공식 사이트그룹 회원", "company":"{{company}}전용 회원"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;